import { Controller } from "@hotwired/stimulus";

// Selezione multipla nella griglia di pianificazione: conteggio, seleziona tutte,
// e scelta del valore (provenienza o tipo lavorazione) in base all'azione.
export default class extends Controller {
  static targets = ["all", "check", "count", "azione", "valoreProvenienza", "valoreTipo", "submit", "submitAi"];

  connect() {
    this.boundUpdate = this.update.bind(this);
    this.element.addEventListener("change", this.boundUpdate);
    this.update();
    this.changeAzione();
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundUpdate);
  }

  checks() {
    return this.checkTargets;
  }

  checkTargetConnected() { this.update(); }

  checkTargetDisconnected() { this.update(); }

  prepareSubmit(event) {
    // L'azione AI è POST; il modulo principale usa invece PATCH.
    const method = event.target.querySelector('input[name="_method"]');
    if (method) method.disabled = event.submitter === this.submitAiTarget;
  }

  toggleAll(event) {
    this.checks().forEach((c) => { c.checked = event.target.checked; });
    this.update();
  }

  update() {
    const n = this.checks().filter((c) => c.checked).length;
    if (this.hasAllTarget) {
      this.allTarget.checked = n > 0 && n === this.checks().length;
      this.allTarget.indeterminate = n > 0 && n < this.checks().length;
      this.allTarget.disabled = this.checks().length === 0;
    }
    if (this.hasCountTarget) this.countTarget.textContent = n;
    if (this.hasSubmitTarget) this.submitTarget.disabled = n === 0;
    if (this.hasSubmitAiTarget) this.submitAiTarget.disabled = !this.checks().some((c) => c.checked && c.dataset.aiEligible === "true");
  }

  changeAzione() {
    if (!this.hasAzioneTarget) return;
    const azione = this.azioneTarget.value;
    const usaTipo = azione === "aggiungi" || azione === "rimuovi";
    const usaProv = azione === "provenienza";
    this.valoreProvenienzaTarget.classList.toggle("d-none", !usaProv);
    this.valoreProvenienzaTarget.disabled = !usaProv;
    this.valoreProvenienzaTarget.name = usaProv ? "valore" : "";
    this.valoreTipoTarget.classList.toggle("d-none", !usaTipo);
    this.valoreTipoTarget.disabled = !usaTipo;
    this.valoreTipoTarget.name = usaTipo ? "valore" : "";
  }
}
